<h1 mat-dialog-title>
  Add Storm Event
</h1>

<mat-dialog-content>
  <form [formGroup]="stormForm" class="flex-column storm-form">
    <mat-form-field class="w-100">
      <mat-label>Storm Name</mat-label>
      <input
        matInput
        formControlName="name"
      >
    </mat-form-field>

    <div class="flex-row">
      <mat-form-field class="w-50">
        <mat-label>From</mat-label>
        <input
          matInput
          [matDatepicker]="fromDatePicker"
          formControlName="from"
          (click)="fromDatePicker.open()"
          (keydown)="fromDatePicker.open()"
        >
        <mat-datepicker-toggle matIconSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #fromDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="w-50">
        <mat-label>From Time</mat-label>
        <input matInput type="time" formControlName="fromTime">
      </mat-form-field>
    </div>

    <div class="flex-row">
      <mat-form-field class="w-50">
        <mat-label>To</mat-label>
        <input
          matInput
          [matDatepicker]="toDatePicker"
          formControlName="to"
          (click)="toDatePicker.open()"
          (keydown)="toDatePicker.open()"
        >
        <mat-datepicker-toggle matIconSuffix [for]="toDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #toDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field class="w-50">
        <mat-label>To Time</mat-label>
        <input matInput type="time" formControlName="toTime">
      </mat-form-field>
    </div>

    @if (stormForm.errors && (fromDateForm.touched || toDateForm.touched)) {
      <div class="storm-errors">
        @if (stormForm.errors?.['toBeforeFrom']) {
          <mat-error>
            Storm End must be after Storm Start.
          </mat-error>
        }
        @if (stormForm.errors?.['rangeTooLong']) {
          <mat-error>
            Range cannot be longer than 3 days.
          </mat-error>
        }
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close cdkFocusInitial>
    Cancel
  </button>
  <button mat-flat-button
          (click)="submitStormEvent()"
          [disabled]="stormForm.invalid || isCreating"
  >
    Save
    @if (isCreating) {
      <mat-spinner [diameter]="15"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
